module.exports = __webpack_public_path__ + "static/09-60e2a5622189d1d89d8ef34da47d98b2.jpg";